import { render, staticRenderFns } from "./PurchaseList.vue?vue&type=template&id=283ad9e8&scoped=true"
import script from "./PurchaseList.vue?vue&type=script&lang=js"
export * from "./PurchaseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283ad9e8",
  null
  
)

export default component.exports